import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2bbe0d1f"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = { class: "indicator" };
import { onMounted } from 'vue';
import { useNotification } from '@/logics/notification';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import Badge from '@/materials/atoms/Badge.vue';
import { useRouter } from 'vue-router';
import { MYPAGE_MESSAGE } from '../main/mypage/types';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const { getUnreadCount } = useNotification();
        const refreshUnreadCount = () => __awaiter(this, void 0, void 0, function* () {
            yield getUnreadCount();
            setTimeout(() => refreshUnreadCount(), 5000);
        });
        const moveMessage = () => {
            store.state.tab = 'mypage';
            store.state.mypageTab = MYPAGE_MESSAGE;
            router.push({
                path: '/trade',
                query: { c: `${store.state.symbol.base}_${store.state.symbol.quote}`, tab: store.state.tab },
            });
        };
        onMounted(() => refreshUnreadCount());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "outer",
                onClick: _withModifiers(moveMessage, ["prevent"])
            }, [
                _createElementVNode("div", _hoisted_2, [
                    (_unref(store).state.unreadNotificationCount > 0)
                        ? (_openBlock(), _createBlock(Badge, {
                            key: 0,
                            "color-mode": "error",
                            class: "indicator-item"
                        }))
                        : _createCommentVNode("", true),
                    _createVNode(MaterialIcon, {
                        class: "middle",
                        name: "notifications"
                    })
                ])
            ], 8, _hoisted_1));
        };
    }
});
